import { render, staticRenderFns } from "./DetailPrestazione.vue?vue&type=template&id=14e1f23a&"
import script from "./DetailPrestazione.vue?vue&type=script&lang=js&"
export * from "./DetailPrestazione.vue?vue&type=script&lang=js&"
import style0 from "./DetailPrestazione.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports